import { useNavigation, useRoute } from '@react-navigation/native';
import { useEffect, useMemo } from 'react';
import useTabs from 'src/components/10-atoms/tabs/useTabs';
import usePersistedState from 'src/hooks/globalState/usePersistedState';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import StorageKeys from 'src/lib/storage/storageKeys';
import useI18n from 'src/modules/translations/hooks/useI18n';
import { clearListPaginationFromLocation } from 'src/utils/pagination/routeListPagination';
import { useSubjectDetailsQuery } from '../../graphql/subject/getDetails';
export default function useData(subjectID) {
    const route = useRoute();
    const navigation = useNavigation();
    const { translate } = useI18n();
    const [subjectDetailsQueryState, subjectDetailsQueryActions] = useSubjectDetailsQuery(subjectID, {
        lazy: true,
    });
    const tabs = useMemo(() => ([
        {
            id: 'PAPERS',
            label: translate('Papers'),
        },
        {
            id: 'TOPICS',
            label: translate('Topics'),
        },
        {
            id: 'NOTES',
            label: translate('Notes'),
        },
        {
            id: 'BOOKMARKS',
            label: translate('Bookmarks'),
        },
        {
            id: 'DIAGRAMS',
            label: translate('Diagrams'),
        },
        {
            id: 'QUESTION_BANK',
            label: translate('Q Bank'),
        },
    ]), [translate]);
    const [lastUsedTab, setLastUsedTab] = usePersistedState(StorageKeys.examPrepSubjectLastUsedGroup, 0);
    const [tabsState, tabsActions] = useTabs({ tabs });
    const setActiveIndex = useStableCallback((index) => {
        const isTabChange = index !== tabsState.activeIndex;
        const nextTab = tabsState.tabs[index];
        if (nextTab && isTabChange) {
            // clear list pagination query params from the URL
            // else the new tab will have the old pagination query params
            clearListPaginationFromLocation();
            navigation.setParams({
                offset: undefined,
                limit: undefined,
            });
        }
        tabsActions.setActiveIndex(index);
    });
    useEffect(() => {
        if (!route.params.tabID && lastUsedTab > 0) {
            setActiveIndex(lastUsedTab);
        }
    }, []);
    useEffect(() => {
        setLastUsedTab(tabsState.activeIndex);
    }, [tabsState.activeIndex]);
    const state = {
        tabs: tabsState,
        subjectDetailsQuery: subjectDetailsQueryState,
    };
    const actions = {
        tabs: {
            ...tabsActions,
            setActiveIndex,
        },
        subjectDetailsQuery: subjectDetailsQueryActions,
    };
    return [state, actions];
}
